<template>
    <div>
        <div class="article-wrapper article-wrapper--header">
            <InnerHeader></InnerHeader>
        </div>
        <Article1 v-if="$route.params.id == 1"></Article1>
        <Article2 v-if="$route.params.id == 2"></Article2>
        <Article3 v-if="$route.params.id == 3"></Article3>
        <Article4 v-if="$route.params.id == 4"></Article4>
        <Article5 v-if="$route.params.id == 5"></Article5>
        <Article6 v-if="$route.params.id == 6"></Article6>
        <Article7 v-if="$route.params.id == 7"></Article7>
        <Article8 v-if="$route.params.id == 8"></Article8>
        <Links></Links>
    </div>
</template>

<script>
import Article1 from '@/pages/Article1.vue'
import Article2 from '@/pages/Article2.vue'
import Article3 from '@/pages/Article3.vue'
import Article4 from '@/pages/Article4.vue'
import Article5 from '@/pages/Article5.vue'
import Article6 from '@/pages/Article6.vue'
import Article7 from '@/pages/Article7.vue'
import Article8 from '@/pages/Article8.vue'
import InnerHeader from '@/components/Header/InnerHeader.vue'
import Links from '@/components/Links/Links.vue'

export default {
  name: 'Article',
  data () {
    return {

    }
  },
  components: {
    Article1, Article2, Article3, Article4, Article5, Article6, Article7, Article8, Links, InnerHeader
  },
  mounted () {
  }
}
</script>

<style scoped>
</style>
